<template>
  <div>
    <b-breadcrumb :items="itemsBread"></b-breadcrumb>
    <div class="p-3">
      <div class="row">
        <div class="col-md-5 mb-2">
          <div class="rounded border p-3" style="background-color: white;">
            <h3>Create Role</h3>
            <div class="form-group">
              <label for="name">Role Name
                <span class="text-danger">*</span>
              </label>
              <input id="name" v-model="role.role_name" class="form-control" placeholder="Enter Role Name" type="text">
            </div>
            <label for="status">Status
              <span class="text-danger">*</span>
            </label>
            <select id="status" v-model="role.active_yn" class="form-control">
              <!--              <option value="">Select Status</option>-->
              <option selected="selected" value="Y">Active</option>
              <option value="N">Inactive</option>
            </select>
            <div class="mt-4">
              <button class="btn btn-light" style="margin-right: 10px;" @click="resetForm">Reset
              </button>
              <button class="btn btn-primary" @click="saveRole">{{ editRole ? 'Update' : 'Save' }}</button>
            </div>
          </div>
        </div>
        <div class="col-md-7 ">
          <div class="rounded border p-3 bg-white">
            <div class="">
              <h3>Role List</h3>
            </div>
            <div class="">
              <b-row class="mt-2">
                <b-col class="col-4 p-1" lg="3" md="4">
                  <b-form-group class="ms-2">
                    <b-form-select id="per-page-select" v-model="perPage" :options="pageOptions"
                                   class="col-md-4" size="sm"></b-form-select>
                  </b-form-group>
                </b-col>
                <!-- search  -->
                <b-col>
                  <div class="d-flex flex-row d-flex justify-content-end">
                    <b-form-input v-model="filter" class="me-2" placeholder="Type to filter data" style="width: 30%;"
                                  type="search"></b-form-input>
                    <button class="rounded btn-info me-4" @click="onSearch">Search</button>
                  </div>
                </b-col>
                <!-- <b-col>
                            <button class="rounded btn-info me-4" @click="onSearch">Search</button>
                        </b-col> -->
              </b-row>
              <b-table :busy="loading" :current-page="currentPage" :fields="fields" :items="roleArray"
                       :per-page="perPage" bordered hover
                       responsive striped>
                <template #cell(actions)="row">
                  <div class="d-flex gap-1 justify-content-center">
                    <button class="btn btn-info btn-sm" type="button" @click="editRoleObject(row.item)">
                      <i class="fa-regular fa-pen-to-square"></i>
                    </button>
                    <button class="btn btn-danger btn-sm" type="button" @click="deleteRole(row.item)">
                      <i class="fa-solid fa-trash"></i>
                    </button>
                  </div>
                </template>
                <template #table-busy>
                  <div class="text-center text-danger my-2 px-2">
                    <b-spinner class="align-middle mx-2"></b-spinner>
                    <strong>Loading...</strong>
                  </div>
                </template>
              </b-table>
              <!-- Pagination -->
              <b-row>
                <b-col class="mt-2" md="12" sm="12">
                  <b-pagination v-model="currentPage" :per-page="perPage" :total-rows="totalRows" align="center"
                                class="my-0" next-text="Next" prev-text="Prev"></b-pagination>
                </b-col>
              </b-row>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RoleService from "@/services/role.service";
import "datatables.net-bs4";
import "datatables.net-bs4/css/dataTables.bootstrap4.min.css";
import "datatables.net-buttons-bs4";
import "datatables.net-buttons-bs4/css/buttons.bootstrap4.min.css";

export default {
  name: 'createRole',

  mounted() {
    this.fetchRole()
  },

  data() {
    return {
      itemsBread: [
        {
          text: 'Home',
          to: '/dashboard'
        }, {
          text: 'User',
          to: '/users/add'
        }, {
          text: 'Create Role',
          href: '#'
        }
      ],
      fields: [
        {
          key: 'role_name', sortable: true, thStyle: {width: "22%"},
          tdClass: "px-3", thClass: "px-3",
        },
        {
          label: 'Status', key: 'active_yn', sortable: true,
          thStyle: {width: "20%"}, tdClass: "px-3", thClass: "px-3",
          formatter: (value) => {
            return value == 'Y' ? 'Active' : 'Inactive'
          },
        },
        {key: 'actions', label: 'Actions', class: 'text-center', thStyle: {width: "20%"},},
      ],
      role: {
        role_id: '',
        role_name: '',
        active_yn: 'Y',
      },
      roleArray: [],
      editRole: false,
      dataTable: null,
      totalRows: 1,
      currentPage: 1,
      perPage: 5,
      pageOptions: [5, 10, 20],
      backupRoleArray: [],
      filter: null,
      loading: false,
    };
  },
  methods: {
    onSearch() {
      if (this.filter != null && this.filter != "") {
        this.roleArray = [];
        this.backupRoleArray.forEach(role => {
          if (role.role_name.toLowerCase().includes(this.filter.toLowerCase())) {
            this.roleArray.push(role);
          }
        });
      } else {
        this.roleArray = this.backupRoleArray;
      }
      this.totalRows = this.roleArray.length;
      this.currentPage = 1;
    },
    showNotification(type, message) {
      this.$notify({
        type: type,
        title: 'Role',
        text: message,
      });
    },
    saveRole() {
      const role = {
        role_id: this.role.role_id,
        role_name: this.role.role_name,
        active_yn: this.role.active_yn,
      };

      if (this.editRole) {
        RoleService.updateRole(role)
            .then(response => {
              this.fetchRole();

              if (response.data) {
                this.showNotification('success', response.data.message);
              } else {
                this.showNotification('error', response.data.message);
              }

            })
            .catch(e => {
                  console.log(e);
                }
            );
      } else {

        RoleService.createRole(role)
            .then(response => {
              this.fetchRole();

              if (response.data) {
                this.showNotification('success', response.data.message);
              } else {
                this.showNotification('error', response.data.message);
              }


            })
            .catch(e => {
                  console.log(e);
                }
            );
      }

      this.resetForm();

    },

    async fetchRole() {
      try {
        const response = await RoleService.fetchRole();
        if (response.data) {
          this.roleArray = response.data;
          this.backupRoleArray = this.roleArray;
          this.totalRows = this.roleArray.length;
        }
      } catch (error) {
        console.error('Error fetching roles:', error);
      }
    },

    editRoleObject(role) {
      this.role.role_name = role.role_name
      this.role.active_yn = role.active_yn
      this.role.role_id = role.role_id

      this.editRole = true
    },

    async deleteRole(role) {
      const result = await this.$swal({
        icon: "warning",
        title: "Are you sure?",
        text: "You won't be able to revert this deletion!",
        showCancelButton: true,
        cancelButtonText: 'No',
        cancelButtonColor: '#007bff',
        showConfirmButton: true,
        confirmButtonText: 'Delete',
        confirmButtonColor: '#dd3333',
      });
      if (result.isConfirmed) {
        const roleId = role.role_id;
        const response = await RoleService.deleteRole({roleId: roleId})
        if (response.data && response.data.status) {
          this.showNotification('success', response.data.message);
          await this.fetchRole()
        } else {
          this.showNotification('error', response.data.message);
        }
      }
    },

    resetForm() {
      this.role = {
        role_id: '',
        role_name: '',
        active_yn: 'Y',
      }
      this.editRole = false
    }
  },
};
</script>